/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-unresolved */
import daviplataByWavaIcon from "images/integrations/daviplata_by_wava.png";
import nequiByWavaIcon from "images/integrations/nequi_by_wava.png";

export const serializePaymentMethods = (data = []) => data.flatMap((item) => (item?.payment_gateway_provider?.key === 'wava'
  ? [
    {
      ...item,
      name: 'Nequi',
      key: 'nequi',
      icon: nequiByWavaIcon,
      selected: true,
      link: 'www.nequi.com.co'
    },
    {
      ...item,
      name: 'Daviplata',
      key: 'daviplata',
      icon: daviplataByWavaIcon,
      selected: true,
      link: 'www.daviplata.com.co'
    }
  ]
  : [item]));
